import React from "react";
import axios from "@/utils/myAxios";
import moment from "moment";
import Cookie from "js-cookie";
import { Link } from "react-router-dom";
import { tableSummaries, isMobileDevice } from "@/utils/utils";
import {
    Button,
    Table,
    Pagination,
    message,
    Modal,
    Select,
    InputNumber,
    Form,
    Checkbox,
    DatePicker,
    Slider,
    Row,
    Col,
    Card,
    Radio,
} from "antd";
import { statusList2 } from "@/utils/constant";

/**
 * 禁用之前日期
 */
const disabledDate = (current) => {
    return current < moment().startOf("day");
};

// 表单数据
const formData = {
    kinds: [1],
    methods: [1],
    level: [0, 0],
    time_range: [moment().add(1, "hours"), moment().add(2, "hours")],
    rank_award: [
        {
            bonus: undefined,
            ticket_id: undefined,
            diamond: undefined,
        }
    ],
};
export default class ActivityHandRank extends React.Component {
    state = {
        loading: false, // 是否加载中
        recordLoading: false, // 记录是否加载中
        show: false, // 添加弹窗
        type: undefined, // 弹窗类型
        title: undefined, // 弹窗标题
        queryParams: {
            // 查询参数
            page: 1,
            limit: 20,
            total: 0,
            status: undefined,
        },
        recordQueryParams: {
            // 记录查询参数
            page: 1,
            limit: 20,
            total: 0,
        },
        statusList: statusList2, // 状态列表
        formData: { ...formData }, // 表单数据
        data: [], // 表格数据
        configData: {}, // 配置数据
        ticketList: [], // 门票
        recordInfo: [], // 记录详情
        playType: [ // 玩法类型
            { label: this.props.language["palyingType1"], value: 1 },
            { label: this.props.language["palyingType2"], value: 3 },
            { label: this.props.language["palyingType3"] + this.props.language["palyingType3Suffix"], value: 4 },
        ]
    };

    componentDidMount () {
        this.fetchData();
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true });
        axios
            .get("/v1/api/activity_leader_board_list", {
                params: {
                    ...this.state.queryParams,
                    status:
                        this.state.queryParams.status !== undefined
                            ? this.state.queryParams.status
                            : -1,
                    total: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    loading: false,
                    queryParams: { ...this.state.queryParams, total: res.count || 0 },
                    data: res.data || [],
                });
            });
    };

    /**
     * 获取配置数据
     */
    fetchConfigData = () => {
        axios.get("/v1/api/activity_leader_board_conf").then((res) => {
            this.setState({
                configData: res.data || {},
            });
        });
    };

    /**
     * 获取门票
     */
    fetchTicketList = () => {
        axios.get("/v1/api/mtt/ticket/conf_list_for_activity").then((res) => {
            this.setState({
                ticketList: res.data || [],
            });
        });
    };

    /**
     * 添加
     */
    handleAdd = () => {
        this.formRef.props.form.validateFields((err, values) => {
            if (!err) {
                // 删除提示字段
                values.rank_award.forEach(item => {
                    delete item.tips
                });
                axios
                    .post("/v1/api/activity_create_leader_board", {
                        kinds: values.kinds,
                        methods: values.methods,
                        begin_level: this.state.configData.blinds[values.level[0]].bb,
                        end_level: this.state.configData.blinds[values.level[1]].bb,
                        begin_time: parseInt(
                            new Date(values.time_range[0]).getTime() / 1000
                        ),
                        end_time: parseInt(new Date(values.time_range[1]).getTime() / 1000),
                        rank_award: values.rank_award,
                    })
                    .then((res) => {
                        if (res.code === 1) {
                            message.success(this.props.language["createSuccessMessage"]);
                            this.fetchData();
                            this.handleClose();
                        }
                    });
            }
        });
    };

    /**
     * 下线活动
     */
    handleOffLine = (id) => {
        Modal.confirm({
            title: this.props.language["hint"],
            content: this.props.language["offlineConfirm"],
            onOk: () => {
                axios
                    .delete(`/v1/api/activity_close_leader_board/${id}`)
                    .then((res) => {
                        if (res.code === 1) {
                            message.success(this.props.language["offlineSuccessMessage"]);
                            this.fetchData();
                        }
                    });
            },
        });
    };

    /**
     * 显示弹窗
     */
    handleShow = (type, item) => {
        let title;
        switch (type) {
            case "add":
                title = this.props.language["createHandRank"];
                this.fetchConfigData();
                this.fetchTicketList();
                break;
            case "view":
                title = this.props.language["activityRecord"];
                if (item.status === 1) {
                    axios
                        .get(`/v1/api/activity_leader_board_rank_result/${item.active_id}`)
                        .then((res) => {
                            if (res.code === 1) {
                                this.setState({
                                    recordInfo: { ...item, rank_result: res.data },
                                });
                            }
                        });
                } else {
                    this.setState({ recordInfo: item });
                }
                break;
        }
        this.setState({ show: true, type, title });
    };

    /**
     * 新增、删除、改变排名奖励
     */
    handelOperationRankReward = (type) => {
        if (type === "add") {
            this.setState({
                formData: {
                    ...this.state.formData,
                    rank_award: [
                        ...this.state.formData.rank_award,
                        {
                            bonus: undefined,
                            ticket_id: undefined,
                            diamond: undefined,
                        },
                    ],
                },
            });
        } else if (type === "delete") {
            this.setState({
                formData: {
                    ...this.state.formData,
                    rank_award: this.state.formData.rank_award.splice(
                        0,
                        this.state.formData.rank_award.length - 1
                    ),
                },
            });
        } else if (type === "change") {
            setTimeout(() => {
                let rank_award = this.formRef.props.form.getFieldValue("rank_award");
                rank_award.forEach((item, index) => {
                    if (item.bonus || item.diamond || item.ticket_id) {
                        rank_award[index].tips = true
                    } else {
                        rank_award[index].tips = undefined
                    }
                });
                this.formRef.props.form.setFieldsValue({
                    rank_award: rank_award,
                })
            })
        }
    };

    /**
     * 关闭弹窗
     */
    handleClose = () => {
        this.formRef.props.form.resetFields();
        this.setState({ show: false, formData: { ...formData } });
    };

    /**
     * 改变分页
     */
    hanldeChangePage = (pagination) => {
        this.setState(
            {
                queryParams: {
                    ...this.state.queryParams,
                    page: pagination.current,
                    limit: pagination.pageSize,
                },
            },
            () => this.fetchData()
        );
    };

    /**
     * 设置查询数据
     */
    handleSetQueryParamsData = (key, value) => {
        this.setState({
            queryParams: { ...this.state.queryParams, page: 1, [key]: value },
        });
    };

    /**
     * 重置
     */
    handleReset = () => {
        this.setState(
            {
                queryParams: {
                    page: 1,
                    limit: 20,
                    total: 0,
                    status: undefined,
                },
            },
            () => {
                this.fetchData();
            }
        );
    };

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        placeholder={this.props.language["statusPlaceholder"]}
                        value={this.state.queryParams.status}
                        onChange={(value) => this.handleSetQueryParamsData("status", value)}
                    >
                        {this.state.statusList.map((item, index) => (
                            <Select.Option value={item.value} key={index}>
                                {item.label}
                            </Select.Option>
                        ))}
                    </Select>
                    <Button
                        type="primary"
                        icon="search"
                        loading={this.state.loading}
                        onClick={this.fetchData}
                    >
                        {this.props.language["query"]}
                    </Button>
                    <Button type="default" icon="reload" onClick={this.handleReset}>
                        {this.props.language["reset"]}
                    </Button>
                    <Button type="primary" ghost onClick={() => this.handleShow("add")}>
                        {this.props.language["createHandRank"]}
                    </Button>
                </div>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={this.state.data}
                        pagination={{
                            showTotal: (total) =>
                                `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                            showQuickJumper: true,
                            showSizeChanger: true,
                            size: isMobileDevice() ? 'small' : '',
                            pageSizeOptions: ["10", "20", "30", "40"],
                            current: this.state.queryParams.page,
                            pageSize: this.state.queryParams.limit,
                            total: this.state.queryParams.total,
                        }}
                        loading={this.state.loading}
                        onChange={this.hanldeChangePage}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language["activityId"]}
                            dataIndex="active_id"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["status"]}
                            dataIndex=""
                            render={(item) =>
                                this.state.statusList.find(
                                    (item2) => item2.value == item.status
                                )
                                    ? this.state.statusList.find(
                                        (item2) => item2.value == item.status
                                    ).label
                                    : ""
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["gameType"]}
                            dataIndex="game_kind"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["playingType"]}
                            dataIndex="game_type"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["levelRange"]}
                            dataIndex="level"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["startTime"]}
                            dataIndex="begin_time"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["endTime"]}
                            dataIndex="end_time"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["totalPrize"]}
                            dataIndex="bonus_amount"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["alreadyWinnPeople"]}
                            dataIndex="bonus_players"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["operation"]}
                            dataIndex=""
                            fixed={isMobileDevice() ? false : "right"}
                            width={200}
                            render={(item) => (
                                <>
                                    <Button
                                        type="default"
                                        onClick={() => this.handleShow("view", item)}
                                    >
                                        {this.props.language["activityRecord"]}
                                    </Button>
                                    <Button
                                        className="ml10"
                                        type="danger"
                                        ghost
                                        disabled={item.status === 2 || item.status === 3}
                                        onClick={() => this.handleOffLine(item.active_id)}
                                    >
                                        {this.props.language["offLine"]}
                                    </Button>
                                </>
                            )}
                        />
                    </Table>
                </div>

                {/* 表单弹窗 */}
                <FormModal
                    {...this.props}
                    visible={this.state.show}
                    type={this.state.type}
                    title={this.state.title}
                    recordLoading={this.state.recordLoading}
                    recordQueryParams={this.state.recordQueryParams}
                    recordInfo={this.state.recordInfo}
                    playType={this.state.playType}
                    configData={this.state.configData}
                    ticketList={this.state.ticketList}
                    statusList={this.state.statusList}
                    formData={this.state.formData}
                    onOk={this.handleAdd}
                    onCancel={this.handleClose}
                    handelOperationRankReward={this.handelOperationRankReward}
                    hanldeChangePage={this.hanldeChangePage}
                    wrappedComponentRef={(formRef) => (this.formRef = formRef)}
                />
            </div>
        );
    }
}

/**
 * 表单弹窗
 */
const FormModal = Form.create({ name: "form_model" })(
    class FormBox extends React.Component {
        render () {
            const { getFieldDecorator, getFieldValue, setFieldsValue } =
                this.props.form;

            return (
                <Modal
                    maskClosable={false}
                    width={this.props.type === "add" ? 600 : 1600}
                    title={this.props.title}
                    visible={this.props.visible}
                    onOk={
                        this.props.type === "add" ? this.props.onOk : this.props.onCancel
                    }
                    onCancel={this.props.onCancel}
                    centered={isMobileDevice()}
                    bodyStyle={{
                        maxHeight: '70vh',
                        overflowY: "auto",
                    }}
                    footer={
                        this.props.type === "add" ? (
                            <>
                                <Button type="default" onClick={this.props.onCancel}>
                                    {this.props.language["cancel"]}
                                </Button>
                                <Button type="primary" onClick={this.props.onOk}>
                                    {this.props.language["confirm"]}
                                </Button>
                            </>
                        ) : (
                            false
                        )
                    }
                >
                    <div className="container-content">
                        {/* 新增 */}
                        {this.props.type === "add" && this.props.configData.games && (
                            <Form>
                                <Form.Item label={this.props.language["gameType"]}>
                                    {getFieldDecorator("kinds[0]", {
                                        rules: [
                                            {
                                                required: true,
                                                message: this.props.language["gameTypeVerify"],
                                            },
                                        ],
                                        initialValue: this.props.formData.kinds[0],
                                    })(
                                        <Radio.Group>
                                            {this.props.configData.games.map((item, index) => (
                                                <Radio key={index} value={item.kind}>
                                                    {item.name}
                                                </Radio>
                                            ))}
                                        </Radio.Group>
                                    )}
                                </Form.Item>
                                {JSON.stringify(getFieldValue('kinds')) === '[1]' &&
                                    <Form.Item label={this.props.language["playingType"]}>
                                        {getFieldDecorator("methods", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: this.props.language["playingTypeVerify"],
                                                },
                                            ],
                                            initialValue: this.props.formData.methods,
                                        })(
                                            <Checkbox.Group>
                                                {this.props.playType.map((item, index) => (
                                                    <Checkbox key={index} value={item.value}>
                                                        {item.label}
                                                    </Checkbox>
                                                ))}
                                            </Checkbox.Group>
                                        )}
                                    </Form.Item>
                                }
                                <Form.Item
                                    label={
                                        <span>
                                            {this.props.language["levelRange"]}
                                            {this.props.language["levelFix"]}：
                                            {this.props.configData.blinds[
                                                getFieldValue("level")
                                                    ? getFieldValue("level")[0]
                                                    : this.props.formData.level[0]
                                            ].bb / 100}
                                            -
                                            {this.props.configData.blinds[
                                                getFieldValue("level")
                                                    ? getFieldValue("level")[1]
                                                    : this.props.formData.level[1]
                                            ].bb / 100}
                                        </span>
                                    }
                                >
                                    {getFieldDecorator("level", {
                                        rules: [
                                            {
                                                required: true,
                                                message: this.props.language["levelRangeVerify"],
                                            },
                                        ],
                                        initialValue: this.props.formData.level,
                                    })(
                                        <Slider
                                            dots
                                            range
                                            tipFormatter={(value) =>
                                                this.props.configData.blinds[value].bb / 100
                                            }
                                            min={0}
                                            max={this.props.configData.blinds.length - 1}
                                        />
                                    )}
                                </Form.Item>
                                <Form.Item label={this.props.language["timeRange"]}>
                                    {getFieldDecorator("time_range", {
                                        rules: [
                                            {
                                                required: true,
                                                message: this.props.language["timeRangeVerify"],
                                            },
                                        ],
                                        initialValue: this.props.formData.time_range,
                                    })(
                                        <DatePicker.RangePicker
                                            disabledDate={disabledDate}
                                            showTime={{ format: "HH:mm" }}
                                            format="YYYY-MM-DD HH:mm"
                                        />
                                    )}
                                </Form.Item>
                                <p className="mb10" style={{ color: "#000000D9", fontSize: 14 }}>
                                    <span>
                                        {this.props.language["award"]}：
                                    </span>
                                    <span>
                                        （
                                        {this.props.language["counterPoint"]}：
                                        {this.props.configData.super_union_point}
                                        ）
                                    </span>
                                </p>
                                {this.props.formData.rank_award.map((item, index) => (
                                    <Row gutter={10} key={index}>
                                        <Col span={18}>
                                            <Form.Item
                                                label={this.props.getLanguage("rankRewrad", index + 1)}
                                            >
                                                {getFieldDecorator(`rank_award[${index}].tips`, {
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: this.props.getLanguage("awardPlaceholder1", index + 1),
                                                        },
                                                    ],
                                                })(
                                                    <></>
                                                )}
                                            </Form.Item>
                                            <Form.Item
                                                labelCol={{ span: 4 }}
                                                wrapperCol={{ span: 20 }}
                                                label={this.props.language["bonus"]}
                                            >
                                                {getFieldDecorator(`rank_award[${index}].bonus`, {
                                                    rules: [
                                                        {
                                                            required: false,
                                                            message: this.props.language["bonusVerify"],
                                                        },
                                                    ],
                                                    initialValue: this.props.formData.rank_award[index]['bonus'],
                                                })(
                                                    <InputNumber
                                                        min={0}
                                                        max={100000000}
                                                        precision={0}
                                                        placeholder={this.props.language["bonusPlaceholder"]}
                                                        onChange={() => this.props.handelOperationRankReward('change')}
                                                    />
                                                )}
                                            </Form.Item>
                                            <Form.Item
                                                labelCol={{ span: 4 }}
                                                wrapperCol={{ span: 20 }}
                                                label={this.props.language["ticket"]}
                                            >
                                                {getFieldDecorator(`rank_award[${index}]['ticket_id']`, {
                                                    rules: [
                                                        {
                                                            required: false,
                                                            message: this.props.language["ticketVerify"],
                                                        },
                                                    ],
                                                    initialValue: this.props.formData.rank_award[index]['ticket_id'],
                                                })(
                                                    <Select
                                                        allowClear
                                                        showSearch
                                                        optionFilterProp="children"
                                                        placeholder={this.props.language["ticketPlaceholder"]}
                                                        onChange={() => this.props.handelOperationRankReward('change')}
                                                    >
                                                        {this.props.ticketList.map((item, index) => (
                                                            <Select.Option value={item.id} key={index}>
                                                                {item.name}（{item.ticket_value}）（{item.id}）
                                                            </Select.Option>
                                                        ))}
                                                    </Select>
                                                )}
                                            </Form.Item>
                                            {/* <Form.Item
                                                labelCol={{ span: 4 }}
                                                wrapperCol={{ span: 20 }}
                                                label={this.props.language["diamond"]}
                                            >
                                                {getFieldDecorator(`rank_award[${index}]['diamond']`, {
                                                    rules: [
                                                        {
                                                            required: false,
                                                            message: this.props.language["diamondVerify"],
                                                        },
                                                    ],
                                                    initialValue: this.props.formData.rank_award[index]['diamond'],
                                                })(
                                                    <InputNumber
                                                        min={0}
                                                        max={100000000}
                                                        precision={0}
                                                        placeholder={this.props.language["diamondPlaceholder"]}
                                                        onChange={() => this.props.handelOperationRankReward('change')}
                                                    />
                                                )}
                                            </Form.Item> */}
                                        </Col>
                                        <Col span={6} style={{ marginTop: isMobileDevice() ? -10 : 4 }}>
                                            {index === this.props.formData.rank_award.length - 1 && (
                                                <Row type="flex" align="middle" gutter={5}>
                                                    {index > 0 && (
                                                        <Col>
                                                            <Button
                                                                shape="circle"
                                                                icon="minus"
                                                                onClick={() =>
                                                                    this.props.handelOperationRankReward("delete")
                                                                }
                                                            />
                                                        </Col>
                                                    )}
                                                    <Col>
                                                        <Button
                                                            shape="circle"
                                                            icon="plus"
                                                            onClick={() =>
                                                                this.props.handelOperationRankReward("add")
                                                            }
                                                        />
                                                    </Col>
                                                </Row>
                                            )}
                                        </Col>
                                    </Row>
                                ))}
                            </Form>
                        )}

                        {/* 活动记录 */}
                        {this.props.type === "view" && (
                            <>
                                {/* 基本信息 */}
                                <Card
                                    title={
                                        <h2>
                                            {this.props.language["basicInfo"]}
                                        </h2>
                                    }
                                    type="inner"
                                >
                                    <Table
                                        dataSource={Object.keys(this.props.recordInfo).length ? [this.props.recordInfo] : []}
                                        pagination={false}
                                        scroll={{ x: true }}
                                        rowKey={(record, index) => index}
                                    >
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["activityId"]}
                                            dataIndex="active_id"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["status"]}
                                            dataIndex=""
                                            render={(item) =>
                                                this.props.statusList.find(
                                                    (item2) => item2.value == item.status
                                                )
                                                    ? this.props.statusList.find(
                                                        (item2) => item2.value == item.status
                                                    ).label
                                                    : ""
                                            }
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["gameType"]}
                                            dataIndex="game_kind"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["playingType"]}
                                            dataIndex="game_type"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["levelRange"]}
                                            dataIndex="level"
                                        />
                                        <Table.Column align="center" title={this.props.language["time"]} render={(item) => `${item.begin_time} ~ ${item.end_time}`} />
                                    </Table>
                                </Card>

                                {/* 奖励配置 */}
                                <Card
                                    title={
                                        <h2>
                                            {this.props.language["rewardConfig"]}
                                        </h2>
                                    }
                                    type="inner"
                                    className="mt20"
                                >
                                    <Table
                                        dataSource={this.props.recordInfo.rank_conf}
                                        pagination={false}
                                        scroll={{ x: true }}
                                        rowKey={(record, index) => index}
                                    >
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["order"]}
                                            dataIndex="rank"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["bonus"]}
                                            dataIndex="bonus_info.point"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["ticketId"]}
                                            dataIndex="bonus_info.ticket_id"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["ticketName"]}
                                            dataIndex="bonus_info.ticket_name"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["diamond"]}
                                            dataIndex="bonus_info.diamond"
                                        />
                                    </Table>
                                </Card>

                                {/* 中奖玩家 */}
                                <Card
                                    title={
                                        <h2>
                                            {this.props.language["winnerPlayer"]}
                                        </h2>
                                    }
                                    type="inner"
                                    className="mt20"
                                >
                                    <Table
                                        dataSource={this.props.recordInfo.rank_result}
                                        pagination={false}
                                        loading={this.props.recordLoading}
                                        onChange={this.props.hanldeChangePage}
                                        scroll={{ x: true }}
                                        rowKey={(record, index) => index}
                                    >
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["winPrizePlayerId"]}
                                            dataIndex="uid"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["winrizePlayerName"]}
                                            dataIndex="name"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["handNumber"]}
                                            dataIndex="hands"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["order"]}
                                            dataIndex="rank"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["bonus"]}
                                            dataIndex="bonus_info.point"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["ticketId"]}
                                            dataIndex="bonus_info.ticket_id"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["ticketName"]}
                                            dataIndex="bonus_info.ticket_name"
                                        />
                                        <Table.Column
                                            align="center"
                                            title={this.props.language["diamond"]}
                                            dataIndex="bonus_info.diamond"
                                        />
                                    </Table>
                                </Card>
                            </>
                        )}
                    </div>
                </Modal>
            );
        }
    }
);
